/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const es_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer más`)
};

const de_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiterlesen`)
};

const nl_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees meer`)
};

const fr_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la suite`)
};

const it_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi di più`)
};

const pt_br2_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia mais`)
};

const pt_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ler mais`)
};

const ja_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続きを読む`)
};

const zh_blog_read_more = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读更多`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_read_more = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_read_more(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_read_more", locale)
	if (locale === "en") return en_blog_read_more(inputs)
	if (locale === "es") return es_blog_read_more(inputs)
	if (locale === "de") return de_blog_read_more(inputs)
	if (locale === "nl") return nl_blog_read_more(inputs)
	if (locale === "fr") return fr_blog_read_more(inputs)
	if (locale === "it") return it_blog_read_more(inputs)
	if (locale === "pt-BR") return pt_br2_blog_read_more(inputs)
	if (locale === "pt") return pt_blog_read_more(inputs)
	if (locale === "ja") return ja_blog_read_more(inputs)
	return zh_blog_read_more(inputs)
};